import { useContext } from 'react';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { WIZARD_EVENTS, useWizardService } from '@bingads-webui-react/wizard';
import { ActionTypes } from './constants';

export const useActionCallback = () => {
  const activity = useContext(ActivityContext);
  const { send } = useWizardService();
  return ({ action, item }) => {
    if (action.type === ActionTypes.View || action.type === ActionTypes.SetUpNow) {
      send(WIZARD_EVENTS.NAVIGATE_TO, {
        stepId: action.stepId,
      });
      activity.trace(`[PmaxNorthStarWizard][SummaryStep][Checks] View action clicked: ${item.locator}`);
    }
  };
};
